import { Coupon, CouponBatch } from "../types/coupons";
export interface CouponStatus {
  value: "Used" | "Active" | "Pending" | "Non active";
  type: "switcher" | "string";
}

export const getCouponStatus = (coupon: Coupon | CouponBatch): CouponStatus => {
  const today = new Date();
  if (coupon.startDate) {
    const couponStartDate = new Date(coupon.startDate);
    if (couponStartDate > today) {
      return {
        value: "Pending",
        type: "string",
      };
    }
  }
  if (!coupon.isActive) {
    return {
      value: "Non active",
      type: "switcher",
    };
  }

  return {
    value: "Active",
    type: "switcher",
  };
};
